import { connect } from 'react-redux';
import { ThreeDots } from 'react-loader-spinner';

const Loader = ({ loading }) => {
    if (!loading) return null;

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            backgroundColor: 'rgba(0,0,0,0.4)', zIndex: 9999
        }}>
            <ThreeDots color="#F5C800" height={80} width={80} />
        </div>
    );
};

const mapStateToProps = state => ({
    loading: state.loader
});

export default connect(mapStateToProps)(Loader);
